/** 분석 도우미 기능 버전. 관리자 앱 전체의 패키지 버전과 별도로 관리한다. */
export const ANALYSIS_ASSISTANT_VERSION = '0.2.0'
export const ANALYSIS_ASSISTANT_TITLE = `분석 도우미 (Beta ${ANALYSIS_ASSISTANT_VERSION})`

export const ANALYSIS_ASSISTANT_RELEASES = [
  {
    version: ANALYSIS_ASSISTANT_VERSION,
    title: '계산 기준을 재사용하고 조회 조건을 확인',
    changes: [
      '등록된 지표를 우선 사용하고, 부족한 항목은 이번 질문의 임시 조회로 제안합니다.',
      '기간·지표·합계 또는 일별 구분·필터·비교 조건을 함께 확인하고, 수정한 뒤 조회합니다.',
      '한 질문에 여러 조회를 실행하고 결과와 개별 조회의 오류를 함께 보여줍니다.',
      '지표 정의 화면에서 계산 기준을 관리하고, 임시 조회의 정의도 검토 후 저장할 수 있습니다.',
      '사용 가이드와 버전 변경 내역을 제공합니다.',
    ],
  },
  {
    version: '0.1.0',
    title: '분석 도우미 초기 베타',
    changes: [
      '미리 준비된 분석 유형을 중심으로 질문에 맞는 분석 하나를 조회했습니다.',
      '분석 결과와 계산 기준을 확인하고 후속 질문으로 조건을 바꿀 수 있었습니다.',
    ],
  },
] as const
